export default __webpack_public_path__ + "static/media/ico_archive.50ccb538.png";